import * as React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import cn from 'classnames';

import { useTheme } from '../../../../theme';

const Loader: React.FC<CircularProgressProps> = ({ classes, size = 19, ...restProps }) => {
	const { Loader: theme } = useTheme('BaseComponents');

	return (
		<CircularProgress
			classes={{
				...classes,
				colorPrimary: cn(theme.colorPrimary, classes?.colorPrimary)
			}}
			size={size}
			{...restProps}
		/>
	);
};

export default Loader;
